import React, { Component } from "react";
import { Helmet } from "react-helmet";
import Layout from "../../../components/layout";
import { ReduxConnect } from "../../../../toolkit/decorators/Artifact";
import {
  configuracionContactCenterStore,
  ConfiguracionContactCenterStore
} from "./ConfiguracionContactCenter.store";
import {
  configuracionContactCenterDispatcher,
  ConfiguracionContactCenterDispatcher
} from "./ConfiguracionContactCenter.dispatcher";
import ConfiguracionContactCenterComponent from "../../../components/comisionesMembresiaConfiguracion/configuracionContactCenter";

interface Props
  extends ConfiguracionContactCenterStore,
    ConfiguracionContactCenterDispatcher {}

@ReduxConnect(
  configuracionContactCenterStore,
  configuracionContactCenterDispatcher
)
export default class ConfiguracionContactCenterContainer extends Component<
  Props
> {
  render() {
    return (
      <main>
        <Layout>
          <Helmet title="Configuración de Contact Center" />
          <ConfiguracionContactCenterComponent {...this.props} />
        </Layout>
      </main>
    );
  }
}
